import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db, auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

const FirebaseStatus = () => {
  const [status, setStatus] = useState('checking');
  const [user, setUser] = useState(null);
  const [details, setDetails] = useState('');

  useEffect(() => {
    const checkStatus = async () => {
      try {
        // Check auth
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
          setUser(currentUser);
          
          if (!currentUser) {
            setStatus('not-logged-in');
            setDetails('Please login first');
            return;
          }

          // Check Firestore
          try {
            await getDocs(collection(db, 'test'));
            setStatus('connected');
            setDetails('Firebase connected & working');
          } catch (error) {
            if (error.code === 'permission-denied') {
              setStatus('permission-denied');
              setDetails('Firestore not enabled or rules not set');
            } else {
              setStatus('error');
              setDetails(error.message);
            }
          }
        });

        return () => unsubscribe();
      } catch (error) {
        setStatus('error');
        setDetails(error.message);
      }
    };

    checkStatus();
  }, []);

  const getStatusColor = () => {
    switch (status) {
      case 'connected': return '#10b981';
      case 'checking': return '#f59e0b';
      case 'not-logged-in': return '#6b7280';
      case 'permission-denied': return '#ef4444';
      case 'error': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'connected': return '✅';
      case 'checking': return '🔄';
      case 'not-logged-in': return '🔒';
      case 'permission-denied': return '⚠️';
      case 'error': return '❌';
      default: return '❓';
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'connected': return 'Firebase Connected';
      case 'checking': return 'Checking...';
      case 'not-logged-in': return 'Not Logged In';
      case 'permission-denied': return 'Firestore Not Enabled';
      case 'error': return 'Connection Error';
      default: return 'Unknown';
    }
  };

  return (
    <div 
    className="firebase-status-indicator"
    style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: 'white',
      padding: '8px 12px',
      borderRadius: '20px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '12px',
      border: `2px solid ${getStatusColor()}`,
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    }}
    title={details}
    >
      <span style={{ fontSize: '14px' }}>{getStatusIcon()}</span>
      <span style={{ fontWeight: '500', color: getStatusColor() }}>
        {getStatusText()}
      </span>
      {user && (
        <span style={{ fontSize: '10px', color: '#6b7280' }}>
          ({user.email})
        </span>
      )}
    </div>
  );
};

export default FirebaseStatus;
